import config from '@/config'
import axios from 'axios'
import { authHeader } from '@/helpers'
import faker from 'faker'
import testProfile from '@/helpers/testProfile'
import { acoToAES, validateObject } from '@/helpers/acoData'
import store from '@/store'


const { API_URL } = config

const AdminURL = `${API_URL}/api/admin`

export const orderService = {
  getProducts,
  getOrders,
  createOrder,
  resendEmail,
  resendAll,
  deleteOrder,
  downloadACO,
  createTestOrder
}

async function getProducts() {
  let url = `${config.API_URL}/api/products`
  let opts = {
    url,
  }
  let res = await axios(opts)
  console.log(url, res)
  return res.data

}
async function downloadACO(orderId) {
  let url = `${config.API_URL}/api/admin/aco/getJSON/${orderId}`
  let opts = {
    url,
    headers: authHeader()
  }
  let res = await axios(opts)
  // console.log(res)
  return res.data
}

function getOrders() {
  let opts = {
    url: `${API_URL}/api/admin/orders`,
    headers: authHeader()
  }
  return new Promise((resolve, reject) => {
    axios(opts)
      .then((res) => {
        let { data } = res
        if (!data) reject(new Error('no data on response'))
        resolve(data)

      })
      .catch(reject)
  })
}

async function createTestOrder() {
  let name = faker.name.findName()
  let email = faker.internet.userName() + '@graffixed.com'
  let productId = store.state.products.products[0].productId
  console.log(`creating test order on /create admin endpoint for ${email}`)
  let data = {
    email: email,
    name: name,
    productId: productId,
    stripeToken: 'tok_visa',
    acoData: testProfile,
  }
  let created = await createOrder(data)
  console.log('createOrder response:', created)
  console.log(`testOrder ${created.orderId} successfully created!`)
  return created


}

function createOrder(orderData) {
  console.log(`creating admin order on /create for ${orderData.email}`)
  let product = store.state.products.products.find(p => p.productId == orderData.productId)
  orderData.price = product.price
  orderData.productTitle = product.productTitle
  console.log(`encrypting acoData`)
  let encryptedACOData = acoToAES(orderData.acoData)
  // console.log(`acoData encrypted to ${encryptedACOData}`)
  delete orderData.acoData
  orderData.acoDataPayload = encryptedACOData
  console.log(`createOrder object for ${orderData.email} ready, see object:`, orderData)
  let opts = {
    url: `${API_URL}/api/admin/orders/create`,
    data: orderData,
    method: 'POST',
    headers: authHeader()
  }
  return new Promise((resolve, reject) => {
    axios(opts)
      .then(res => {
        let { data } = res
        if (!data.success) {
          reject(new Error(data.error))
        } else {
          resolve(data.order)
        }
      })
      .catch(reject)
  })
}

async function deleteOrder(orderId) {
  let url = `${AdminURL}/orders/id/${orderId}`
  let opts = { url, headers: authHeader(), method: 'delete' }
  try {
    let res = await axios(opts)
    return res
  } catch (e) {
    console.error(e)
  }
}

async function resendEmail(orderId) {
  let opts = {
    url: `${API_URL}/api/admin/orders/resendEmail/${orderId}`,
    headers: authHeader(),
  }
  let res = await axios(opts)
  return res
}

async function resendAll() {
  let opts = {
    url: `${API_URL}/api/admin/orders/resendAll`,
    headers: authHeader(),
  }
  let res = await axios(opts)
  return res
}